export default __webpack_public_path__ + "static/media/Manual-2.80e2afea.png";